export default {
  get (name) {
    let cookies = document.cookie
    let cookieName = name

    if (cookies.length > 0) {
      let cookieStart = cookies.indexOf(cookieName + '=')
      if (cookieStart !== -1) {
        cookieStart = cookieStart + cookieName.length + 1
        let cookieEnd = cookies.indexOf(';', cookieStart)

        if (cookieEnd === -1) {
          cookieEnd = cookies.length
        }
        return unescape(cookies.substring(cookieStart, cookieEnd))
      }
    }
    return null
  },
  create (name, value, days) {
    let expires = ''
    const cookieDomain = process.env.COOKIE_DOMAIN

    if (days) {
      let date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + value + '; domain=' + cookieDomain + expires + '; path=/'
  },
  delete (name) {
    const cookieDomain = process.env.COOKIE_DOMAIN
    document.cookie = name + '=; domain=' + cookieDomain + '; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/'
  }
}
